<template>
  <div>
    <!-- 填入什么就返回什么，排除前后空格 《新批量专用》》-->
    <el-container>
      <el-header>
        <div>
          <div class="titleBtn flex">
            <div class="titleText">
            </div>
            <div>
              <el-button type="text" @click="emptyListFun">清空</el-button>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside>
        </el-aside>
        <el-main>
          <div>
            <div>
              <el-input v-model="desc" placeholder="请输入数据，每行一个" type="textarea" :autosize="{ minRows: 19 }"></el-input>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <div class="downBtn flex">
    <div><el-button @click="cnanelFun()">取消</el-button></div>
    <div><el-button @click="confirmFun()" type="primary">确定</el-button></div>
  </div>
</template>

<script>
import { reactive, toRefs, inject, watch, watchEffect } from 'vue'
import { ElMessage } from 'element-plus'
export default {
  name: 'insertViewBatch',
  // 1. 核心修复：声明组件要触发的自定义事件
  emits: ['getCannelFun', 'getDataListFun'],
  components: {},
  // 接收页面的传值
  props: ['datas', 'descParam'],
  setup(props, context) {
    const state = reactive({
      // 数据列表
      dataList: props.datas,
      //输入框的值
      desc: props.descParam,
      // 清空
      emptyListFun: () => {
        //给desc赋值
        state.dataList = []

        state.desc = ''
      },
      // 取消
      cnanelFun: () => {
        context.emit('getCannelFun')
      },
      // 确定
      confirmFun: () => {
        if (state.desc.length == 0) {
          return ElMessage({
            type: 'error',
            message: '请填写数据',
          })
        } else {
          state.dataList = state.desc
            .split(/\r?\n/)
            .map(item => item.trim()) // 每一行去除首尾空格
            .filter(item => !!item)   // 过滤掉空字符串、全空格行

          context.emit('getDataListFun', { 'dataList': state.dataList, 'desc': state.desc })
        }
      },

    })

    // 监听descParam的变化
    watch(() => props.descParam, (newVal) => {
      state.desc = newVal
    })

    // 监听 datas 的变化
    watch(() => props.datas, (newVal) => {
      state.dataList = newVal
    })

    return { ...toRefs(state) }
  },
}
</script>

<style lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #f9fafa;
  color: #333;
  line-height: 30px;
  height: 40px;
  border: 1px solid #e9e9e9;
}

.el-aside {
  background-color: #ffffff;

  width: 0px;
  text-align: center;
  border: 0px solid #e9e9e9;
}

.el-main {
  background-color: #fcffff;
  color: #333;
  height: 410px;
  border: 1px solid #e9e9e9;
  padding: 0px;
}

body>.el-container {
  margin-bottom: 20px;
}

.titleBtn {
  justify-content: space-between;
}

.titleText {
  font-size: 16px;
  line-height: 40px;
}







.downBtn {
  justify-content: flex-end;
  padding: 10px 10px 0px 15px;

  >div {
    padding-left: 30px;
  }
}
</style>
